// Copyright (c) 2016 Deere & Company

import RgaRecalledPart from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    additionalDataFlag: state.rga.searchResults.additionalDataFlag,
    additionalDataInfo: state.rga.searchResults.additionalDataInfo,
    additionalDataTest: state.rga.searchResults.additionalDataTestDomain,
    additionalDataType: state.rga.searchResults.additionalDataTypeDomain,
    analysisStatus: state.rga.shared.rgaDomainValues.analysisStatus,
    busyCounter: state.rga.searchResults.busyCounter,
    currentStatus: state.rga.shared.rgaDomainValues.rgaRecallStatus.currentStatus,
    files: state.rga.searchResults.file,
    genericStatus: state.rga.shared.rgaDomainValues.rgaRecallStatus.genericStatus,
    infoReqStatus: state.rga.shared.rgaDomainValues.rgaRecallStatus.infoReqStatus,
    partReqStatus: state.rga.shared.rgaDomainValues.rgaRecallStatus.partReqStatus,
    photoReqStatus: state.rga.shared.rgaDomainValues.rgaRecallStatus.photoReqStatus,
    requesterType: state.rga.shared.rgaDomainValues.requesterType,
    rgaConsignmentDetails: state.rga.searchResults.rgaConsignmentDetails,
    rgaDealerDetails: state.rga.searchResults.rgaDealerDetails,
    rgaDetails: state.rga.searchResults.rgaDetails,
    rgaQuestionAnswer: state.rga.searchResults.rgaQuestionAnswer,
    rgaUnits: state.rga.shared.rgaDomainValues.rgaUnits,
    security: state.user.security
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        queryParams: parentProps.location && parentProps.location.query,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(RgaRecalledPart);



// WEBPACK FOOTER //
// ./src/rga/recalled-part-analysis/state-connector.js